export function generateSvgDataUrl(letter: string) {
  const solidColors = [
    "#16a085",
    "#f1c40f",
    "#f39c12",
    "#27ae60",
    "#d35400",
    "#2980b9",
    "#c0392b",
    "#8e44ad",
    "#2c3e50",
  ];
  const randomIndex = new Uint32Array(1);
  window.crypto.getRandomValues(randomIndex);
  const bgColor = solidColors[randomIndex[0] % solidColors.length];
  const text = letter.toUpperCase();

  const svg = `
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="128" height="128">
        <circle cx="64" cy="64" r="64" fill="${bgColor}" />
        <text x="50%" y="50%" text-anchor="middle" dy=".35em"
              font-family="sans-serif" font-size="64" fill="#ffffff">
          ${text}
        </text>
      </svg>
    `;

  // Encode and convert to Data URL
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");

  return `data:image/svg+xml;charset=UTF-8,${encoded}`;
}